import React from 'react'
import Advance_program_card from './Advance_program_card'

function Advance_program_content() {
  return (
    <div>
      <div className='py-5'>
      
      {/* ----------------------Mobile View---------------------------- */}
      <div className='container d-sm-block d-md-none'>
        <div className='text-center About_Discraption_text'>
            <h1 className='display-4'>What’s in store for YOU ?</h1>
        </div>
      </div>


      {/* ----------------------------Desktop View--------------------------- */}
      <div className='container pb-4 pt-3 d-none d-md-block'>
        <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-4 pb-4'>What’s in store for YOU ?</h1>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
      </div>

      <div>
        <div className='container pt-4'>
            <Advance_program_card/>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Advance_program_content
